import { getOptionsProvider } from '@shared/OptionsProvider';
import type { PkTheme } from '@shared-types/common.types';
import type { RoundPhase } from '@shared-types/match.types';
import type { MenuItem } from '@shared-types/menu.types';

export type HeaderCompetition = {
  id: string;
  matchIds: string[];
  phase?: RoundPhase;
  name?: string;
  qualName?: string;
  prequalName?: string;
  intName?: string;
  code?: string;
};

export type HeaderOptions = {
  menu: MenuItem[];
  libraryPath?: string;
  isCompetitionContext: boolean;
  liveScoreInterval: number;
  liveScoreCompetitions: string[];
  activateLoginButton: boolean;
  customUserPage?: string;
  theme?: PkTheme;
};

export const { OptionsProvider: HeaderOptionsProvider, useOptions: useHeaderOptions } =
  getOptionsProvider<HeaderOptions>();
